import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import useDeviceType from "../../../custom-hooks/DeviceType";
import EventEHRSwitchButton from "../../../component-lib/Molecules/switch-button/EventEHRSwitchButton";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";
import MenuDropdown from "../../../component-lib/Molecules/menuDropdown/MenuDropdown";
import WrapperCard from "../../../component-lib/Atoms/card/EventEHRWrapperCard";
import Heading from "../../../component-lib/Atoms/heading/EventEHRHeading";
import SelectDropdown from "../../../component-lib/Atoms/Select/Select";
import SearchSelectDropdown from "../../../component-lib/Atoms/SearchSelectDropdown/EventEHRSearchSelectDropdown";
import {
  DownloadIcon,
  plusIcon,
  rightDirectionBlackIcon,
  searchIcon,
} from "../../../assets";
import Button from "../../../component-lib/Molecules/button/Button";
import Table from "../../../component-lib/Organisms/table/EventEHRTable";
import { formatPhoneNumber } from "../../../utils/phoneNumberFormatter";
import { componentKey, setCloseAddUserDialog } from "../SettingsSlice";
import {
  getAdminUsers,
  patchAdminUsersData,
  postUserData,
  deleteAdminUser,
  sendAdminUserInvitation,
  sendAdminUserBulkInvitation,
} from "../SettingsSaga";
import ViewAdminDialog from "../dialogs/ViewAdminDailog";
import AdminUserProfileDialog from "../dialogs/AdminUserProfileDialog";
import EventEHRConfirmationDialog from "../../../component-lib/Molecules/confimation-dialog/EventEHRConfirmationDialog";
import ImportAdminUsersDialog from "../dialogs/ImportAdminUsers";
import ImportResultsDialog from "../../inventory-screen/dialogs/ImportResultsDialog";
import { importAdminUsersResultsColumns } from "../dialogs/importAdminUsersResultsColumns";
import { handleImportData } from "../../../utils/handleImportData ";
import SettingsService from "../../../services/SettingsService";
import moment from "moment";

const AdminUserScreen = () => {
  const { closeAddUserDialog, adminUserList } = useSelector(
    (state: any) => state[componentKey]
  );

  const location = useLocation();
  const { selectedUser } = useParams();

  const { user } = location.state || {};

  const typingTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [rowPerPage, setRowPerPage] = useState("10");
  const [pageNumber, setPageNumber] = useState(1);
  const [searchedValue, setSearchValue] = useState<string>("");
  const [status, setStatus] = useState("");
  // OPEN USER PROFILE DIALOG
  const [openUserProfileDialog, setOpenUserProfileDialog] = useState(false);

  //OPEN ADMIN USER VIEW DAILOG
  const [selectedUserRow, setSelectedUserRow] = useState();
  const [openViewUserAdmin, setOpenViewUserAdmin] = useState(false);

  //OPEN AMDIN USER EDIT DAILOG
  //const [isEdit, setIsEdit] = useState(false);
  const [selectedUserTask, setSelectedUserTask] = useState<any>({});
  //const [isDisable, setIsDisable] = useState(false);

  // DELETE USER CONFIRMATION DIALOG STATE
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);

  // BULK SEND-INVITATION SELECTION STATE
  const [selectedRowsForInvite, setSelectedRowsForInvite] = useState<any[]>([]);

  // IMPORT ADMIN USERS STATE
  const [openImportAdminUsersDialog, setOpenImportAdminUsersDialog] =
    useState(false);
  const [isImporting, setIsImporting] = useState(false);
  const [importMessage, setImportMessage] = useState<string | null>(null);
  const [openImportResultsDialog, setOpenImportResultsDialog] = useState(false);
  const [importResults, setImportResults] = useState<any>(null);

  const deviceType = useDeviceType();

  const defaultTaskData = {
    userName: "",
    lastLogin: "",
    contactNumber: "",
    email: "",
    status: "",
    role: "",
  };

  // USER COLUMN DATA
  const UserColumns = [
    {
      field: "userName",
      label: <div>{user || "User"} Name</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.userName}</p>;
      },
    },
    {
      field: "role",
      label: <div>Role</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.role}</p>;
      },
    },
    {
      field: "lastLogin",
      label: <div>Last Login</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.lastLogin}</p>;
      },
    },
    {
      field: "contactNumber",
      label: <div>Contact Number</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.contactNumber}</p>
        );
      },
    },
    {
      field: "email",
      label: <div>Email</div>,
      renderLogic: (row: any) => {
        return <p className="text-neutral-90 font-normal">{row?.email}</p>;
      },
    },
    {
      field: "providerAccess",
      label: <div>Provider Access</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.providerAccess}</p>
        );
      },
    },
    {
      field: "status",
      label: <div>Status</div>,
      renderLogic: (row: any, index: any) => {
        const status =
          row?.status === "Active"
            ? true
            : row?.status === "InActive"
              ? false
              : false;
        return (
          <div className="text-neutral-90 font-normal flex justify-start gap-1 items-center">
            <EventEHRSwitchButton
              checked={status}
              onChange={() => {
                const apiPayload = {
                  payload: {
                    status: status ? "InActive" : "Active",
                  },
                  userId: row?.userId,
                };
                dispatch(patchAdminUsersData(apiPayload));
              }}
            />
          </div>
        );
      },
    },
    {
      field: "action",
      label: <div>{TEXT_CONSTANTS?.ACTION}</div>,
      renderLogic: (row: any) => {
        return (
          <>
            <div className="flex items-center">
              <MenuDropdown
                options={[
                  {
                    label: "View Profile",
                    onClickCb: () => {
                      setSelectedUserRow(row);
                      setOpenViewUserAdmin(true);
                    },
                  },
                  {
                    label: "Edit Profile",
                    onClickCb: () => {
                      setSelectedUserTask(row);
                      setOpenUserProfileDialog(true);
                    },
                  },
                  {
                    label: "Send Invitation",
                    onClickCb: () => {
                      dispatch(
                        sendAdminUserInvitation({ id: row?.userId })
                      );
                    },
                  },
                  {
                    label: "Delete Profile",
                    onClickCb: () => {
                      setSelectedUserId(row?.userId);
                      setOpenConfirmationDialog(true);
                    },
                  },
                ]}
              />
            </div>
          </>
        );
      },
    },
  ];

  // USER ROW DATA
  const UserRowData = adminUserList?.adminUsers?.map((data: any) => ({
    id: data?.bsaId || "-",
    userName: data?.firstName ? data?.firstName + " " + data?.lastName : "-",
    lastLogin: data?.lastLogin
      ? moment(data?.lastLogin).format("MM/DD/YYYY [at] HH:mm")
      : "-",
    contactNumber: data?.contactNumber
      ? formatPhoneNumber(data?.contactNumber)
      : "-",
    email: data?.email || "-",
    status: data?.status || false,
    userId: data?.id,
    gender: data?.gender,
    role: data?.type === "SuperAdmin" ? "Super Admin" : data?.type?.replace(/([a-z])([A-Z])/g, "$1 $2"),
    // Store original API values for editing
    originalRole: data?.type, // Store original API role value
    originalGender: data?.gender, // Store original API gender value
    originalProviderAccess: data?.providerAccess, // Store original API provider access value
    providerAccess: data?.providerAccess,
  }));

  useEffect(() => {
    if (closeAddUserDialog) {
      getAdminUser();
      dispatch(setCloseAddUserDialog(false));
      setOpenUserProfileDialog(false);
      setOpenConfirmationDialog(false); // Reset confirmation dialog
      setSelectedUserId(null); // Reset selected user ID
    }
  }, [closeAddUserDialog]);

  useEffect(() => {
    if (selectedUser === "admin-user") {
      getAdminUser();
    }
  }, [searchedValue, rowPerPage, pageNumber, status]);

  const getAdminUser = () => {
    const payload = {
      pageNumber: pageNumber,
      limit: rowPerPage,
      name: searchedValue?.trim(),
      status: status ? status : "",
    };
    dispatch(getAdminUsers(payload));
  };

  const handleImportAdminUsersData = async (
    formData: Record<string, unknown>
  ) => {
    await handleImportData(formData, {
      service: SettingsService.uploadAdminUsersFile,
      onRefresh: getAdminUser,
      asyncMessage: "Admin Users import started successfully.",
      setIsImporting,
      setImportMessage,
      setImportResults,
      setOpenImportResultsDialog,
      setOpenImportInventoryDialog: setOpenImportAdminUsersDialog,
    });
  };

  // HANDLE SEARCH CHANGE VALUE AND ADDED SOME DELAY
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPageNumber(1);

    const value = e.target.value;

    // CLEAR THE PREVIOUS TIMEOUT
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current);
    }

    // SET A NEW TIMEOUT TO DELAY THE CALLBACK
    typingTimeoutRef.current = setTimeout(() => {
      setSearchValue(value?.trim());
    }, 500); // ADJUST DELAY AS NEEDED
  };

  const addUser = (data: any) => {
    console.log("data:", data);
    let payload = {};
    if (selectedUser === "admin-user") {
      payload = {
        bsaId: data?.bsaId,
        firstName: data?.firstName,
        lastName: data?.lastName,
        contactNumber: data?.contactNumber || undefined,
        email: data?.email,
        gender: data?.gender,
        type: data?.role,
        providerAccess: data?.providerAccess || "no", // Default to "no" if no option is selected
      };
      if (selectedUserTask?.userId) {
        const userUpDatePayload = {
          payload: {
            ...payload,
            bsaId: undefined,
          },
          userId: selectedUserTask?.userId,
        };
        dispatch(patchAdminUsersData(userUpDatePayload));
      } else {
        dispatch(postUserData(payload));
      }
    }
  };

  return (
    <WrapperCard
      customClasses="m-3 p-3 flex-1 min-h-0"
      customStyle={{ minWidth: deviceType !== "mobile" ? "400px" : "" }}
    >
      <div className="flex flex-col h-full gap-3">
        <div
          className={`flex ${deviceType === "mobile" ? "flex-col items-start gap-3" : "items-center"} justify-between w-full`}
        >
          <div className="flex items-center gap-3">
            <img
              className="cursor-pointer"
              src={rightDirectionBlackIcon}
              alt="back-arrow"
              style={{ height: "12.5px" }}
              onClick={() => {
                navigate("/settings");
              }}
            />
            <Heading
              title={`${user} User`}
              customStyle={{ color: "#1D1D1D" }}
            />
          </div>

          <div
            className={`flex ${deviceType === "mobile" ? "w-full justify-between" : ""} gap-3`}
          >
            <div style={{ maxWidth: "350px" }}>
              <SelectDropdown
                label=""
                name="status"
                placeholderValue="All Status"
                displayEmpty={true}
                value={status}
                options={[
                  { label: "Active", value: "Active" },
                  { label: "In Active", value: "InActive" },
                ]}
                onChangeCb={(e) => {
                  setPageNumber(1);
                  setStatus(e.target.value);
                }}
              />
            </div>
            <div>
              <SearchSelectDropdown
                freeSolo={true}
                searchedValue={searchedValue}
                onSearchValueChangeCb={(e) => handleChange(e)}
                size="small"
                label="Search by name, email, contact number"
                fullWidth={deviceType === "mobile" ? "160px" : "300px"}
                startIcon={
                  <img
                    alt="search-icon"
                    src={searchIcon}
                    width={"18px"}
                    height={"18px"}
                  />
                }
              />
            </div>

            <Button
              startIcon={
                <img
                  src={DownloadIcon}
                  alt={"import"}
                  className="cursor-pointer w-[19px] h-[19px]"
                />
              }
              label="Import Users"
              variant="outlined"
              onClickCb={() => setOpenImportAdminUsersDialog(true)}
              style={{
                paddingTop: "6px",
                paddingBottom: "6px",
                minWidth: "155px",
                backgroundColor: "white",
                border: "1px solid #005596",
                color: "#005596",
              }}
            ></Button>

            {selectedRowsForInvite.length > 0 && (
              <Button
                label={`Send Invitation${
                  selectedRowsForInvite.length > 1
                    ? ` (${selectedRowsForInvite.length})`
                    : ""
                }`}
                variant="contained"
                onClickCb={() => {
                  const ids = selectedRowsForInvite.map(
                    (r: any) => r?.userId
                  );
                  dispatch(sendAdminUserBulkInvitation({ ids }));
                }}
                style={{
                  paddingTop: "6px",
                  paddingBottom: "6px",
                  minWidth: "155px",
                }}
              ></Button>
            )}

            <Button
              startIcon={
                <img
                  src={plusIcon}
                  alt={"search"}
                  className="cursor-pointer w-[19px] h-[19px]"
                />
              }
              label={`Add ${user}`}
              variant="contained"
              onClickCb={() => {
                setSelectedUserTask({});
                setOpenUserProfileDialog(true);
              }}
              style={{
                paddingTop: "6px",
                paddingBottom: "6px",
                minWidth: "155px",
              }}
            ></Button>
          </div>
        </div>
        <div style={{ overflow: "auto" }}>
          <Table
            columns={UserColumns}
            rows={UserRowData}
            selectProps={{
              isSelectAll: true,
              isSelectable: true,
              onSelectRowsCb: setSelectedRowsForInvite,
              selectIdentifier: "userId",
              onSelectAll: () => {},
            }}
            paginationProps={{
              isPagination: true,
              page: pageNumber,
              totalPages: adminUserList?.totalPages,
              totalCount: adminUserList?.totalRecords,
              limit: rowPerPage,
              rowsPerPageOptions: [10, 25, 50],
              onPageChange: (page: any) => {
                setPageNumber(page);
              },
              handleChangeRowsPerPage: (rowPerPage: any) => {
                setRowPerPage(rowPerPage);
                setPageNumber(1);
              },
            }}
          />
        </div>
      </div>
      {/* ADD USER DIALOG */}
      {openUserProfileDialog && (
        <AdminUserProfileDialog
          selectedUserTask={selectedUserTask}
          user={user}
          isOpen={openUserProfileDialog}
          handleClose={() => {
            setOpenUserProfileDialog(false);
            setSelectedUserTask(null);
          }}
          handleData={(data) => {
            addUser(data);
          }}
        />
      )}
      {openViewUserAdmin && (
        <ViewAdminDialog
          dialogHeading="View Admin Profile"
          isOpen={openViewUserAdmin}
          taskData={selectedUserRow || defaultTaskData}
          handleClose={() => {
            setOpenViewUserAdmin(false);
          }}
        />
      )}

      {/* DELETE USER CONFIRMATION DIALOG */}
      {openConfirmationDialog && (
        <EventEHRConfirmationDialog
          alertTitle={`Delete ${user}`}
          alertDescription={`Are you sure you want to delete this ${user}? Please confirm to proceed.`}
          cancelButtonTitle="Cancel"
          submitButtonTitle="Delete"
          open={openConfirmationDialog}
          handleClose={(action) => {
            if (action === "close") {
              setOpenConfirmationDialog(false);
              setSelectedUserId(null);
            } else if (action === "submit") {
              if (selectedUserId) {
                const payload = {
                  id: selectedUserId,
                };
                dispatch(deleteAdminUser(payload));
              }
            }
          }}
        />
      )}

      {openImportAdminUsersDialog && (
        <ImportAdminUsersDialog
          isOpen={openImportAdminUsersDialog}
          handleClose={() => {
            setOpenImportAdminUsersDialog(false);
            setImportMessage(null);
          }}
          handleImportAdminUsersData={(
            formData: Record<string, unknown>
          ) => {
            handleImportAdminUsersData(formData);
          }}
          isImporting={isImporting}
          importMessage={importMessage}
        />
      )}

      <ImportResultsDialog
        isOpen={openImportResultsDialog}
        handleClose={() => {
          setOpenImportResultsDialog(false);
          setImportResults(null);
        }}
        results={importResults}
        invalidColumns={importAdminUsersResultsColumns}
      />
    </WrapperCard>
  );
};

export default AdminUserScreen;
